















































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import AddPageMedia from '@/web/components/pages/AddPageMedia.vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import PageButtonEditor from './PageButtonEditor.vue';
import PageStyle from '@/web/components/pages/PageStyle.vue';
import PageColorPickerModal from './PageColorPickerModal.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';

interface LocalState {
  inProgress: boolean;
  localPageChanges?: PageChanges;
  iframeUrl: string;
  previewUrl: string;
}

interface PageChanges {
  html: string;
  main_css: string;
  section_css: string;
}

export default Vue.extend({
  name: 'PagesBuilder',
  components: {
    TopNav,
  },
  mixins: [DirtyMixin],
  data(): LocalState {
    return {
      inProgress: false,
      localPageChanges: undefined,
      iframeUrl: `${process.env.VUE_APP_PAGE_BUILDER_BASE_URL}/iframe-edit`,
      previewUrl: `${process.env.VUE_APP_PAGE_BUILDER_BASE_URL}/preview`,
    };
  },
  computed: {
    ...mapGetters({
      page: 'page/page',
      pageColors: 'page/pageColors',
      formSaveFun: 'globals/formSaveFun',
      pagesLocationUrl: 'setting/pagesLocationUrl',
    }),
    showPageStyle() {
      return this.page?.from_template;
    },
  },
  methods: {
    eventsMapper(event) {
      if (typeof event.data == 'object') {
        const { type, payload } = event.data;
        if (!type) return;
        switch (type) {
          case 'LOADED':
            this.loadPage();
            break;
          case 'UPDATE':
            this.update(payload);
            break;
          case 'OPEN_BUTTON_EDITOR':
            this.$modal.show(
              // @ts-ignore
              PageButtonEditor,
              {
                btn: payload,
                successFn: button => this.postToIframe('UPDATE_BUTTON', button),
              },
              {
                classes: ['vm--button-editor-modal'],
              }
            );
            break;
          case 'OPEN_ADD_MEDIA':
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.ADD_IMAGE') },
              {},
              { addPageMedia: src => this.postToIframe('ADD_MEDIA', src) }
            );
            break;
          case 'OPEN_UPDATE_MEDIA':
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.UPDATE_IMAGE') },
              {},
              { addPageMedia: src => this.postToIframe('UPDATE_MEDIA', src) }
            );
            break;
          case 'OPEN_UPDATE_BACKGROUND_COLOR':
            this.$modal.show(
              PageColorPickerModal,
              {
                inputColor: payload,
                customColors: this.pageColors,
              },
              {
                classes: ['vm--color-picker-modal'],
              },
              {
                'color-selected': color => {
                  this.postToIframe('UPDATE_BACKGROUND_COLOR', color);
                },
              }
            );
            break;
          case 'OPEN_UPDATE_TEXT_COLOR':
            this.$modal.show(
              PageColorPickerModal,
              {
                inputColor: payload,
                customColors: this.pageColors,
              },
              {
                classes: ['vm--color-picker-modal'],
              },
              {
                'color-selected': color => {
                  this.postToIframe('UPDATE_TEXT_COLOR', color);
                },
              }
            );
            break;
          case 'OPEN_UPDATE_BACKGROUND_MEDIA':
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.ADD_BACKGROUND_IMAGE') },
              {},
              {
                addPageMedia: src =>
                  this.postToIframe('UPDATE_BACKGROUND_MEDIA', src),
              }
            );
            break;
          case 'OPEN_IMAGE_PICKER':
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.ADD_IMAGE') },
              {},
              {
                addPageMedia: src => this.postToIframe('IMAGE_SELECTED', src),
              }
            );
            break;
          case 'OPEN_COLOR_PICKER':
            console.log('payload', payload);
            this.$modal.show(
              PageColorPickerModal,
              {
                inputColor: payload,
                customColors: this.pageColors,
              },
              {
                classes: ['vm--color-picker-modal'],
              },
              {
                'color-selected': color => {
                  this.postToIframe('UPDATE_COLOR', color);
                },
              }
            );
            break;
          case 'OPEN_MEDIA_PICKER':
            console.log('MEDIA_SELECTED', payload);
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.ADD_IMAGE') },
              {},
              {
                addPageMedia: src => this.postToIframe('MEDIA_SELECTED', src),
              }
            );
            break;
          case 'OPEN_ASSET_PICKER':
            this.$modal.show(
              AddPageMedia,
              { title: this.$t('PAGES.TITLE.ADD_IMAGE') },
              {},
              {
                addPageMedia: src => this.postToIframe('UPDATE_ASSET', src),
              }
            );
            break;
        }
      }
    },
    postToIframe(type, payload?) {
      this.$refs['editor-iframe'].contentWindow?.postMessage(
        {
          type,
          payload: payload ? JSON.parse(JSON.stringify(payload)) : payload,
        },
        '*'
      );
    },
    loadPage() {
      if (this.page) {
        const {
          html,
          main_css,
          section_css,
          from_template,
          css_variables,
          custom_head,
          insert_head,
        } = this.page;
        this.postToIframe('LOAD', {
          html,
          main_css,
          section_css,
          from_template,
          css_variables,
          custom_head,
          insert_head,
        });
      }
    },
    updatePage() {
      if (this.page) {
        const { css_variables } = this.page;
        this.postToIframe('UPDATE_PAGE', {
          css_variables,
        });
      }
    },
    update(payload) {
      this.setDirty();
      this.localPageChanges = payload;
    },
    toggleBuilderMode() {
      this.postToIframe('TOGGLE_BUILDER_MODE');
    },
    async preview() {
      await this.savePage();
      window.open(
        `${this.pagesLocationUrl}/${this.page.slug}?show_unpublished=true`,
        '_blank'
      );
    },
    pageUndo() {
      this.postToIframe('UNDO');
    },
    pageRedo() {
      this.postToIframe('REDO');
    },
    pageStyle() {
      this.$modal.show(
        PageStyle,
        {},
        {
          classes: ['vm--button-editor-modal'],
        }
      );
    },
    async savePage() {
      if (!this.localPageChanges) return;
      this.inProgress = true;

      const pagePayload = { ...this.page, ...this.localPageChanges };

      const tagRegex = /<[^>]+>/g;
      if (pagePayload.main_css) {
        try {
          pagePayload.main_css = Array.from(
            new Set(pagePayload.main_css?.match(tagRegex))
          ).join(' ');
        } catch (error) {
          console.error(error);
        }
      }
      if (pagePayload.section_css) {
        try {
          pagePayload.section_css = Array.from(
            new Set(pagePayload.section_css?.match(tagRegex))
          ).join(' ');
        } catch (error) {
          console.error(error);
        }
      }

      try {
        await this.$store.dispatch('page/updatePage', {
          id: this.page.id,
          data: pagePayload,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('PAGES.NOTIFICATIONS.PAGE_SUCCESSFULLY_UPDATED'),
        });
        this.clearDirty();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(
            error.response,
            `${this.$t('PAGES.NOTIFICATIONS.FAILED_TO_UPDATE_PAGE')}: ${error}`
          ),
        });
      } finally {
        this.inProgress = false;
      }
    },
  },
  async mounted() {
    const id = this.$route.params.id;
    await this.$store.dispatch('page/loadPage', id);
    this.clearDirty();

    window.addEventListener('message', this.eventsMapper, false);
  },
  destroyed() {
    window.removeEventListener('message', this.eventsMapper);
    this.clearDirty();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isDirty && this.page.status === 'unpublished') {
      this.$modal.show(HMDialog, {
        title: this.$t('PAGES.TITLE.READY_TO_PUBLISH'),
        text: this.$t('PAGES.TEXT.YOUR_PAGE_IS_SAVED_BUT'),
        confirmButton: this.$t('PAGES.BUTTON.PUBLISH'),
        discardButton: this.$t('GENERAL.BUTTON.BACK'),
        confirm: async () => {
          await this.$store.dispatch('page/publishPage', this.page.id);
          next();
        },
        discard: () => {
          next();
        },
      });
    } else {
      next();
    }
  },
  watch: {
    page() {
      this.loadPage();
    },
  },
});
